import { KYMW6000Model } from '../kymw6000.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * CWS使用画像一覧表(全体)を取得する
 *
 * @export GetCwsPlanGoodsUseImageGroupDispListService
 * @class GetCwsPlanGoodsUseImageGroupDispListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCwsPlanGoodsUseImageGroupDispListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW6000Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCwsPlanGoodsUseImageGroupDispListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        CwsPlanGoodsUseImageList: {
          condition: {
            OrderCode: this.model.orderCode,
            ClassCode: this.model.classCode,
            MediumType: this.model.mediumType,
            PCode: this.model.pCode,
            CatalogId: this.model.catalogId,
            FeatureCode: this.model.featureCode,		
            MultiOrCrossFlg: this.model.multiOrCrossFlg,	
            ImageNoUseFlag: this.model.imageNoUseFlg,
            ImageCheckFlag: this.model.imageCheckFlg,
            StartDispNum: 1,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCwsPlanGoodsUseImageGroupDispListService
   */
  execute(model: KYMW6000Model, successFunc: Function = null): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getCwsPlanGoodsUseImageGroupDispList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCwsPlanGoodsUseImageGroupDispListService
   */
  success(data: any): void {
    // レスポンスのファイルパスをマネージに保存
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
